import { render } from "./OverviewLayout.vue?vue&type=template&id=0bedccf6&ts=true"
import script from "./OverviewLayout.vue?vue&type=script&lang=ts"
export * from "./OverviewLayout.vue?vue&type=script&lang=ts"

import "./OverviewLayout.vue?vue&type=style&index=0&id=0bedccf6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__